/* DGDelivery: exact port of the live product page's delivery estimate
   (live/sections/custom-jacob-product.liquid, showEstimate(), ~line 1864).
   Same 5 pm ET cutoff, same FedEx Ground ZIP3 table, same ipapi.co lookup,
   same strings. Proven equal to the old code by delivery.test.mjs; do not
   change the date maths here without re-running it.
   Classic script, no dependencies, drop-in as a Shopify theme asset.
     DGDelivery.estimate(nowMs, zip3) -> result (pure, no DOM, any client time zone)
     DGDelivery.init(onUpdate)        -> old flow: cached ZIP3, else 088 now, then ipapi.co
     DGDelivery.mountLegacy(sectionId) fills the old #pdp-* markup exactly as before
     DGDelivery.setZip(zip, onUpdate) "Deliver to ZIP" field (not in the old code) */
(function (w) {
  'use strict';
  // FedEx Ground transit table, copied byte-for-byte from the live section by script. Do not hand-edit.
  var _FXC={"d":{"a":[2,2,2,2,3],"b":[3,3,3,4,3],"c":[4,6,6,6,6],"d":[3,3,5,5,5],"e":[1,1,1,1,3],"f":[2,2,2,4,4],"g":[3,3,2,4,3],"h":[2,2,2,4,3]},"m":{"a":"032,033,035,038,039,040,041,042,043,044,045,046,048,049,054,056,058,059,129,140,141,144,145,147,153,155,157,158,159,161,162,163,164,166,167,168,201,215,221,222,224,225,226,227,228,229,230,231,233,234,238,239,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255,256,257,258,259,260,261,262,263,264,265,266,267,270,275,278,279,281,283,284,285,286,287,288,289,290,291,294,295,296,297,298,299,302,305,306,307,308,309,310,312,313,314,317,318,319,350,351,355,356,357,359,360,361,362,367,368,370,371,373,375,376,377,378,380,382,383,384,385,386,387,388,389,390,391,392,397,400,401,403,404,406,407,408,409,410,411,412,413,414,415,416,417,418,420,421,422,423,424,425,426,427,430,431,433,434,435,437,438,439,444,446,448,449,451,453,456,457,458,460,461,465,467,468,469,470,471,472,473,474,475,476,477,478,479,484,485,486,487,488,490,491,492,493,494,496,497,526,527,528,530,609,610,611,612,613,614,615,616,617,618,619,620,622,623,624,625,626,627,628,629,630,633,634,637,638,639,716,720,721,723,724","2":"030,031,142,143,146,150,151,152,154,156,160,165,220,223,232,235,236,237,240,271,272,273,274,276,277,280,282,292,293,300,301,303,311,352,358,372,374,379,381,402,405,432,436,440,441,442,443,445,447,450,452,454,455,459,462,463,464,466,480,481,482,483,489,495,531,532,534,600,601,602,603,604,605,606,607,608,631,722","b":"304,315,316,320,321,323,324,326,344,354,363,364,365,369,393,394,395,396,398,500,501,502,504,506,507,508,510,511,512,513,514,515,516,520,521,522,523,524,525,535,537,538,539,540,541,542,543,544,545,546,547,548,549,550,555,557,558,559,560,563,570,571,581,636,640,644,645,647,648,650,651,652,653,654,655,656,657,660,664,665,666,667,668,670,671,673,674,678,679,680,688,689,703,704,705,706,707,710,711,712,713,714,718,726,728,729,730,734,735,736,737,740,743,744,745,746,747,748,749,754,755,756,757,758,759,762,763,764,765,766,767,769,774,776,777,778,779,780,781,783,784,788,789,790,791,792,793,794,795,796,797,881,882","3":"322,325,327,328,329,330,331,332,333,334,335,336,337,338,339,341,342,346,347,349,366,503,509,551,553,554,641,649,658,661,662,672,681,685,700,701,708,727,731,733,741,750,751,752,753,760,761,770,772,773,775,782,786,787","d":"498,499,505,556,561,562,564,565,566,567,572,573,574,575,576,580,582,583,584,585,635,646,669,675,676,683,684,686,687,692,717,738,739,768,883,884","g":"719","h":"725","c":"577,586,587,588,590,591,592,594,595,596,597,598,599,677,690,691,693,785,798,799,800,801,802,803,804,805,806,807,808,809,810,811,812,813,814,815,816,820,821,822,824,825,826,827,828,850,851,852,853,855,856,857,859,860,863,864,865,870,871,873,874,875,877,878,879,880,885,890,891,900,901,902,903,904,905,906,907,908,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,930,931,932,933,934,935","7":"593,823,829,830,831,832,833,834,835,836,837,838,840,841,842,843,844,845,846,847,893,894,895,897,898,936,937,938,939,940,941,942,943,944,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,970,971,972,973,974,975,976,977,978,979,980,981,982,983,984,985,986,988,989,990,991,992,993,994","1":"010,011,012,013,014,015,016,017,018,019,020,021,022,023,024,025,026,027,028,029,034,036,037,050,051,052,053,055,057,060,061,062,063,064,065,066,067,068,069,070,071,072,073,074,075,076,077,078,079,080,081,082,083,084,085,086,087,088,089,100,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,130,131,132,133,134,135,136,137,138,139,148,149,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,206,207,208,209,210,211,212,214,216,217,218,219","e":"005,101,202,203,204,205","f":"047,268,399"}};
  var FXG={};(function(){var d=_FXC.d,m=_FXC.m;for(var k in m){var zips=m[k].split(",");var v=d[k]||parseInt(k);for(var i=0;i<zips.length;i++)FXG[zips[i]]=v;}})();
  function fxgTransit(zip3, shipDay) {
    var entry = FXG[zip3];
    if (!entry) return 4;
    if (typeof entry === 'number') return entry;
    var idx = shipDay - 1;
    if (idx < 0 || idx > 4) idx = 0;
    return entry[idx];
  }

  var H = 3600000, KEY = 'dg_zip3', DEFAULT_ZIP3 = '088', fp, fs, fl, fw;
  function fmt(o) { o.timeZone = 'UTC'; return new Intl.DateTimeFormat('en-US', o); }
  function setup() {
    if (fp) return;
    fp = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric',
      month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
    fs = fmt({ weekday: 'short', month: 'short', day: 'numeric' });
    fl = fmt({ weekday: 'long', month: 'long', day: 'numeric' });
    fw = fmt({ weekday: 'long' });
  }
  // New York wall clock of an instant, held as a UTC timestamp (so the visitor's own
  // time zone never touches it). Seconds kept, milliseconds dropped, like the old
  // new Date(new Date().toLocaleString('en-US', {timeZone: 'America/New_York'})).
  function wall(ms) {
    var p = fp.formatToParts(new Date(ms)), g = {};
    for (var i = 0; i < p.length; i++) g[p[i].type] = +p[i].value;
    return Date.UTC(g.year, g.month - 1, g.day, g.hour % 24, g.minute, g.second);
  }
  // The real instant the old code got back when it parsed a New York wall time
  // (the earlier one in the repeated 1 am hour), used only for its countdown.
  function instant(W) { return wall(W + 4 * H) === W ? W + 4 * H : W + 5 * H; }
  function addBizDays(W, n) {
    var x = new Date(W), a = 0;
    while (a < n) { x.setUTCDate(x.getUTCDate() + 1); if (x.getUTCDay() !== 0 && x.getUTCDay() !== 6) a++; }
    return x.getTime();
  }
  function iso(W) { return new Date(W).toISOString().slice(0, 10); }
  function span(ms) {
    var h = Math.floor(ms / H), m = Math.floor((ms % H) / 60000);
    return h > 0 ? h + 'h ' + m + 'm' : m + 'm';
  }

  function estimate(nowMs, zip3) {
    setup();
    var W = wall(nowMs == null ? Date.now() : nowMs), n = new Date(W);
    var hour = n.getUTCHours(), min = n.getUTCMinutes(), dow = n.getUTCDay();
    var shipsToday = hour < 17 && dow >= 1 && dow <= 5;
    var ship = shipsToday ? W : addBizDays(W, 1);
    var transit = fxgTransit(zip3, new Date(ship).getUTCDay());
    var delivery = addBizDays(ship, transit);
    var overnight = addBizDays(hour < 17 ? W : ship, 1);
    var shipLabel, within;
    if (shipsToday) {
      // Old formula, kept as is: at exactly hh:00 it shows one hour less than is left.
      var hl = 17 - hour - 1, ml = 60 - min;
      if (ml === 60) ml = 0;
      within = hl > 0 ? hl + 'h ' + ml + 'm' : ml + 'm';
      shipLabel = 'Ships Today';
    } else {
      var s = new Date(ship), t = new Date(W);
      var diff = instant(Date.UTC(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate(), 17)) - instant(W);
      within = span(diff < 0 ? 0 : diff);
      t.setUTCDate(t.getUTCDate() + 1);
      shipLabel = 'Ships ' + (iso(t.getTime()) === iso(ship) ? 'Tomorrow' : fw.format(s));
    }
    return {
      shipsToday: shipsToday,
      shipDateISO: iso(ship),
      deliveryDateISO: iso(delivery),
      deliveryShort: fs.format(new Date(delivery)),   // "Thu, Oct 8"
      deliveryLong: fl.format(new Date(delivery)),    // "Thursday, October 8" (old code computed but never showed this)
      shipLabel: shipLabel,                           // "Ships Today" | "Ships Tomorrow" | "Ships Monday"
      orderWithin: within,                            // "3h 12m" | "45m" (shown as "Order within " + this)
      overnightWeekday: fw.format(new Date(overnight)),
      overnightDateISO: iso(overnight),
      transitDays: transit,
      zip3Used: zip3,
      zip3Known: !!FXG[zip3]
    };
  }

  function store(z3) { try { sessionStorage.setItem(KEY, z3); } catch (e) {} }
  function init(onUpdate) {
    var cached = null;
    try { cached = sessionStorage.getItem(KEY); } catch (e) {}
    if (cached) { onUpdate(estimate(Date.now(), cached)); return; }
    onUpdate(estimate(Date.now(), DEFAULT_ZIP3));
    if (typeof fetch !== 'function') return;
    fetch('https://ipapi.co/json/', { cache: 'force-cache' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var zip = data.postal;
        if (zip && zip.length >= 3) {
          var z3 = zip.substring(0, 3);
          if (FXG[z3]) { store(z3); onUpdate(estimate(Date.now(), z3)); }
        }
      })
      .catch(function () {});
  }
  // Extension for a "Deliver to ZIP" field: same rule as the ipapi path (only a known
  // ZIP3 is cached). Returns false for a ZIP the table does not know.
  function setZip(zip, onUpdate) {
    var z3 = String(zip || '').replace(/\D/g, '').substring(0, 3);
    if (z3.length < 3 || !FXG[z3]) return false;
    store(z3);
    if (onUpdate) onUpdate(estimate(Date.now(), z3));
    return true;
  }
  // Writes the old markup's ids with the old strings (custom-jacob-product.liquid ~line 840).
  function fill(sid, r, doc) {
    doc = doc || document;
    var g = function (id) { return doc.getElementById(id + sid); };
    var del = g('pdp-delivery-msg-'), ov = g('pdp-overnight-tx-'), box = g('pdp-ships-today-'),
      tx = g('pdp-ships-today-tx-'), lb = g('pdp-ships-label-');
    if (del) del.innerHTML = '<strong>' + r.deliveryShort + '</strong><span>Delivered</span>';
    if (ov) ov.innerHTML = 'Overnight available — by <strong>' + r.overnightWeekday + '</strong>';
    if (box) {
      if (lb) lb.textContent = r.shipLabel;
      if (tx) tx.textContent = 'Order within ' + r.orderWithin;
    }
  }
  function mountLegacy(sid, doc) {
    doc = doc || document;
    if (!doc.getElementById('pdp-delivery-msg-' + sid)) return;
    init(function (r) { fill(sid, r, doc); });
  }

  w.DGDelivery = { estimate: estimate, init: init, setZip: setZip, fill: fill, mountLegacy: mountLegacy,
    transit: fxgTransit, known: function (z3) { return !!FXG[z3]; }, KEY: KEY };
})(typeof window !== 'undefined' ? window : this);
